import { MaskedInputProps } from '../../types';
import { MaskedInput } from './Input';

export function InputDUV(props: MaskedInputProps) {
  return <MaskedInput {...props} mask="000000/0000" />;
}
